// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';

export const SignInContentBlockDynamic = dynamic(() =>
  import('./SignInContentBlock').then(module => module.SignInContentBlockEditable)
);
export { SignInContentBlockEditable } from './SignInContentBlock';
export { SignInContentBlock } from './SignInContentBlock';
